export default "__VITE_ASSET__5YXQzX33__"